'use client';

import { memo, type ReactNode } from 'react';

import { AIcon, XIcon } from '@air/design-icons';

import { IconButton } from '~/components/IconButton';

export type TitleBarProps = {
  /** Handler for close button click */
  onClose?: () => void;
  /** Additional actions to render on the right side (before close button) */
  actions?: ReactNode;
};

export const TitleBar = memo(({ onClose, actions }: TitleBarProps) => {
  return (
    <header className="flex h-12 shrink-0 items-center justify-between border-neutral-4 border-b bg-white px-3 dark:bg-neutral-1">
      <div className="flex items-center gap-2">
        <AIcon size="lg" />
        <span className="font-medium text-14 text-neutral-12">Air</span>
      </div>

      <div className="flex items-center gap-1">
        {actions}
        {onClose && (
          <IconButton aria-label="Close" className="rounded-6 text-neutral-11" onClick={onClose}>
            <XIcon size="md" />
          </IconButton>
        )}
      </div>
    </header>
  );
});

TitleBar.displayName = 'TitleBar';
